export default __webpack_public_path__ + "static/media/logistics.ae5d15cf.svg";